import { render } from "./DadosAtendimento.vue?vue&type=template&id=1e5f688a"
import script from "./DadosAtendimento.vue?vue&type=script&lang=js"
export * from "./DadosAtendimento.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__